import React, { useState } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { AffiliateCodeModal } from './AffiliateCodeModal';
import SettingsIcon from '../CustomSVGIcons/SettingsIcon';
import { AffiliateListModal } from './AffiliateListModal';
import {
    bentoCardSx,
    bentoLabelSx,
    bentoManageValueSx,
    bentoSubtextSx,
    OBSIDIAN,
} from '../../constants/obsidianDashboardTheme';

export const AffiliateCode: React.FC<{ obsidianBento?: boolean }> = ({ obsidianBento }) => {
    const { themeStyle } = useThemeContext();
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showListModal, setShowListModal] = useState(false);

    const cardSx = obsidianBento
        ? {
              ...bentoCardSx,
              width: '100%',
              height: '100%',
              mt: 0,
              cursor: 'pointer',
              '&:hover': { bgcolor: OBSIDIAN.surfaceContainerHigh },
          }
        : {
              backgroundColor: theme[themeStyle].secondaryBg,
              borderRadius: '10px',
              width: '100%',
              height: '100%',
              padding: '24px',
              minHeight: '200px',
              position: 'relative',
              boxShadow: `0px 0px 3px ${theme[themeStyle].gray_sidebar}`,
              mt: 2,
              cursor: 'pointer',
              '&:hover': {
                  backgroundColor: theme[themeStyle].secondaryBg,
                  transform: 'translateY(-2px)',
                  transition: 'all 0.2s ease-in-out',
              },
          };

    return (
        <>
            <Box
                style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
                sx={cardSx}
                onClick={() => setShowCreateModal(true)}>
                <IconButton
                    onClick={e => {
                        e.stopPropagation();
                        setShowListModal(true);
                    }}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: obsidianBento ? OBSIDIAN.onSurfaceVariant : theme[themeStyle].grey,
                        '&:hover': {
                            color: obsidianBento ? OBSIDIAN.primary : theme[themeStyle].highlight,
                        },
                    }}>
                    <SettingsIcon stroke={theme[themeStyle].grey} width="20px" height="20px" />
                </IconButton>

                <Box>
                    <Typography
                        sx={
                            obsidianBento
                                ? bentoLabelSx
                                : {
                                      fontSize: 14,
                                      fontFamily: FONT_ENUM.MAIN_MEDIUM,
                                      color: theme[themeStyle].form_label,
                                      textTransform: 'uppercase',
                                  }
                        }>
                        Affiliate Codes
                    </Typography>
                    <Typography
                        sx={
                            obsidianBento
                                ? bentoManageValueSx
                                : {
                                      fontSize: 24,
                                      fontWeight: '500',
                                      fontFamily: FONT_ENUM.MAIN_BOLD,
                                      color: theme[themeStyle].filters_white,
                                  }
                        }>
                        Manage
                    </Typography>
                    <Typography
                        sx={
                            obsidianBento
                                ? bentoSubtextSx
                                : {
                                      fontSize: 14,
                                      fontWeight: '200',
                                      fontFamily: FONT_ENUM.MAIN_MEDIUM,
                                      color: theme[themeStyle].grey,
                                  }
                        }>
                        Create and manage affiliate codes
                    </Typography>
                </Box>
            </Box>

            <AffiliateCodeModal open={showCreateModal} onClose={() => setShowCreateModal(false)} />
            <AffiliateListModal open={showListModal} onClose={() => setShowListModal(false)} />
        </>
    );
};
